// 📁 components/ProfileImage.jsx
import React, { useState, useEffect, useMemo } from "react";

// Helper to determine the API root from environment variables
const getApiRoot = () => {
    const apiBase =
        (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
        process.env.REACT_APP_API_BASE_URL ||
        "http://localhost:5000/api";

    // Strip trailing /api if present to get the root host/port
    return apiBase.replace(/\/api\/?$/, "");
};

const API_ROOT = getApiRoot();
const DEFAULT_AVATAR = "/default-avatar.png";


const ProfileImage = ({
    src,
    className = "profile-avatar",
    alt = "Profile",
}) => {
    const [imageSrc, setImageSrc] = useState(DEFAULT_AVATAR);
    const root = useMemo(() => API_ROOT, []);

    useEffect(() => {
        if (!src || src === DEFAULT_AVATAR) {
            setImageSrc(DEFAULT_AVATAR);
            return;
        }

        // External URL check
        if (src.startsWith("http://") || src.startsWith("https://")) {
            setImageSrc(src);
            return;
        }

        // Dynamic Relative Path Construction
        const normalised = src.startsWith("/") ? src : `/${src}`;
        setImageSrc(`${root}${normalised}`);

    }, [src, root]);

    const handleError = () => {
        // Fallback to the safe default if the image load fails
        if (imageSrc !== DEFAULT_AVATAR) {
            setImageSrc(DEFAULT_AVATAR);
        }
    };

    return (
        <img
            src={imageSrc}
            alt={alt}
            className={className}
            onError={handleError}
            loading="lazy"
        />
    );
};

export default ProfileImage;